import * as React from "react";
import type { SVGProps } from "react";
const SvgCustomersUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24" {...props}
  >
    <path
      stroke="#28293D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.25 19c0-2.2 1.8-4 4-4h4c2.2 0 4 1.8 4 4M10.75 6.001c1.4 1.4 1.4 3.6 0 4.9s-3.6 1.4-4.9 0-1.4-3.5-.1-4.9 3.6-1.3 5 0M16.25 14h3c1.7 0 3 1.3 3 3M19.55 6.702c1 1 1 2.6 0 3.5s-2.6 1-3.5 0-1-2.6 0-3.5c.9-.9 2.5-.9 3.5 0"
    />
  </svg>
);
export default SvgCustomersUser;
